import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-comparison-cards', 'compareDetails', 'Сравнить детали');
Labels.set('ui-comparison-cards', 'available', 'Доступный');
Labels.set('ui-comparison-cards', 'notAvailable', 'Heдоступный');
Labels.set('ui-comparison-cards', 'comparisonItem1', 'Объект сравнения 1');
Labels.set('ui-comparison-cards', 'comparisonItem2', 'Объект сравнения 2');
Labels.set(
    'ui-comparison-cards',
    'selectProductsCompare',
    'Выберите, какие продукты сравнивать.'
);
